import { render, staticRenderFns } from "./CrudMdFilterItemBtn.vue?vue&type=template&id=98cb860a&scoped=true&"
import script from "./CrudMdFilterItemBtn.vue?vue&type=script&lang=js&"
export * from "./CrudMdFilterItemBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98cb860a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
